import { render, staticRenderFns } from "./ShowFrozenPlaceholder.vue?vue&type=template&id=c694462a&scoped=true&"
import script from "./ShowFrozenPlaceholder.vue?vue&type=script&lang=js&"
export * from "./ShowFrozenPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./ShowFrozenPlaceholder.vue?vue&type=style&index=0&id=c694462a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c694462a",
  null
  
)

export default component.exports